import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { FormControl, Select, MenuItem, Grid, Typography, TextField, Button, Container } from '@mui/material';
import { useDispatch } from 'react-redux';
import UserService from '../../../services/user_service';
import { Visible } from '../../../layouts/Visible';
import Page from '../../../components/Page';

const useStyles = styled((theme) => ({
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

function UserMessages() {
    const theme = useTheme();
    const classes = useStyles(theme);
    const [message, setMessage] = useState('')
    const params = useParams();
    const dispatch = useDispatch();

    const [form, setForm] = useState({
        user_message: '',
    });


    useEffect(() => {
        dispatch({ type: 'USER', payload: { 'user': params.user_id } })
    }, []);

    useEffect(() => {
        return () => {
            dispatch({ type: '' })
        }
    }, [])


    const handleChange = (event) => {
        setForm({
            ...form,
            [event.target.id]: event.target.value,
        });
    };

    const onSubmit = (event) => {
        event.preventDefault();

        if (form.user_message === '') {
            return;
        }
        UserService.sendMessageToUser([params.user_id], form.user_message)
            .then((data) => setMessage(data['result']))
            .catch((error) => {
                if (error.response) {

                }
            })

    };


    return (
        <Visible roles={["admin"]}>
            <Page title="Send message to user">
                <Container>
                <Typography variant="h4" sx={{ mb: 5 }}>
                    Send message to user
                </Typography>
                    <form className={classes.root} noValidate autoComplete="off">
                        <Grid container spacing={4} >
                            <Grid item xs={12} sm={12} md={12}>
                                <TextField
                                    label="Message"
                                    name="user_message"
                                    id="user_message"
                                    multiline
                                    rows={6}
                                    required
                                    fullWidth
                                    onChange={handleChange}
                                    value={form.user_message}
                                // error={!!form.currentPassword}
                                // helperText={form.currentPassword && 'Обязательное поле'}
                                />
                            </Grid>


                            <Grid item xs={12} sm={12} md={12}>
                                <Button onClick={onSubmit} variant="contained" color="primary">
                                    Send
                                </Button>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12}>
                                {message}
                            </Grid>
                        </Grid>
                    </form >
                </Container>
            </Page>

        </Visible >
    );
}

export default UserMessages;